import React from 'react'

export default function Info1() {
  return (
    <section id='nosotros' className="info1-section py-16 md:py-24 bg-base-200">
      <div className="container mx-auto  md:px-8">
       
        <div className='card shadow-2xl grid grid-cols-1 md:grid-cols-1 gap-6 md:gap-8 max-w-7xl mx-auto fade-in-on-scroll'>
        <h1 className="h1-info1 text-3xl md:text-4xl lg:text-5xl font-bold piel2">
        ¿Qué son los Gases de Efecto Invernadero?
          </h1>
        <div style={{alignItems:'baseline'}} className="card grid grid-cols-1 md:grid-cols-3 max-w-7xl mx-auto fade-in-on-scroll">
          
          <div style={{justifySelf:'end'}} className="card w-full">
            <div className="card-body">
              <h2 className="card-title piel">El Efecto Invernadero Natural</h2>
              <p className='piel2 nobile'>El efecto invernadero es un proceso natural que calienta la superficie terrestre. Algunos gases atmosféricos, como el vapor de agua y el dióxido de carbono, funcionan como una manta invisible que retiene parte del calor del sol, permitiendo que la temperatura sea apta para la vida. Sin este efecto natural, la temperatura promedio de la Tierra sería aproximadamente -18°C, haciendo imposible la vida tal como la conocemos.</p>
            <ul>
              <li>Vapor de agua: Principal gas de efecto invernadero natural</li>
              <li>CO₂ natural: Vital para el ciclo del carbono</li>
              <li>Metano: Presente en procesos naturales</li>
            </ul>
            
            </div>
          </div>

          <div style={{justifySelf:'end'}} className="card w-full">
            <div className="card-body">
              <h2 className="card-title piel">El Problema del Aumento</h2>
              <p className='piel2 nobile'>Las actividades humanas han alterado dramáticamente el balance natural, liberando cantidades excesivas de gases de efecto invernadero. La quema de combustibles fósiles, la deforestación, la agricultura intensiva y los procesos industriales han aumentado la concentración de estos gases a niveles sin precedentes en los últimos 800,000 años. Este incremento está intensificando el efecto invernadero natural, provocando un calentamiento global peligroso y cambios climáticos significativos.</p>
            <ul>
              <li>CO₂: Aumento del 48% desde la era preindustrial</li>
              <li>Metano: Incremento del 156% por actividad humana</li>
              <li>Óxido nitroso: 23% más alto que niveles naturales</li>
            </ul>
            
            </div>
          </div>

          <div style={{justifySelf:'end'}} className="card w-full">
            <div className="card-body">
              <h2 className="card-title piel">Consecuencias Globales</h2>
              <p className='piel2 nobile'>El aumento de los gases de efecto invernadero está causando cambios significativos en nuestro planeta. El incremento de la temperatura global está provocando el derretimiento de los glaciares, la elevación del nivel del mar, eventos climáticos extremos y alteraciones en los ecosistemas. Estos cambios afectan la agricultura, la disponibilidad de agua, la biodiversidad y la salud humana, creando desafíos sin precedentes para las sociedades actuales y futuras.</p>
            <ul>
              <li>Aumento del nivel del mar: 3.3 mm/año</li>
              <li>Pérdida de hielo ártico: 13% por década</li>
              <li>Incremento de eventos extremos: 46%</li>
            </ul>
            
            </div>
          </div>


          </div>

          

          
          

          
        </div>
        
      </div>
    </section>
  )
}
